/* istanbul ignore file */
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {getLeftRightAlignment} from '../../../getAlignmentUtils';

export const getProductQuickAddCustomCssVars = (customCssVarsFnParams: CustomCssVarsFnParams) => {
  const {styleParams} = customCssVarsFnParams;

  return {
    quickAddContentAlignment: getLeftRightAlignment(styleParams.strings.gallery_quickAddContentAlignment.value),
  };
};
